(() => {
  'use strict';
  const configElement = document.getElementById('outwest-quote-page-context');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const isContact = (path) => /\/pages\/contact\/?$/.test(path);
  if (!isContact(location.pathname)) {
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest?.('a[href]');
      if (!anchor || anchor.hasAttribute('download')) return;
      let destination;
      try { destination = new URL(anchor.href, location.origin); } catch { return; }
      if (destination.origin !== location.origin || !isContact(destination.pathname)) return;
      destination.searchParams.set('source_path', location.pathname);
      destination.searchParams.set('source_title', String(config.title || '').slice(0, 200));
      if (config.product) {
        destination.searchParams.set('product', String(config.product).slice(0, 200));
        const selected = document.querySelector('main form[action*="/cart/add"] [name="id"]');
        const variant = selected?.value || config.variant;
        if (/^\d+$/.test(String(variant))) destination.searchParams.set('variant', variant);
      }
      anchor.href = destination.href;
    });
    return;
  }
  const params = new URLSearchParams(location.search);
  const path = params.get('source_path') || '';
  const title = (params.get('source_title') || '').slice(0, 200);
  const product = (params.get('product') || '').slice(0, 200);
  const variant = params.get('variant') || '';
  // Accept only a path on this store; never put arbitrary external URLs in enquiries.
  let source = '';
  if (path.startsWith('/') && !path.startsWith('//') && !/[\\?#\r\n]/.test(path)) {
    const candidate = new URL(path, location.origin);
    if (candidate.origin === location.origin) source = candidate.href;
  }
  const panel = document.querySelector('[data-quote-context]');
  const label = panel?.querySelector('[data-quote-source-label]');
  const field = panel?.querySelector('[data-quote-source-field]');
  if (source && panel && label && field) {
    field.value = `${product || title || path} — ${source}`;
    const specificContext = path !== '/' && (product || title);
    if (specificContext) {
      label.textContent = product || title;
      panel.hidden = false;
    }
  }
  const variantField = document.querySelector('[data-quote-variant-field]');
  if (source && product && variantField && /^\d+$/.test(variant)) variantField.value = variant;
  const products = document.querySelector('[data-quote-products]');
  if (source && product && products && !products.value.trim()) {
    products.value = product;
  }
})();
